import type { FC } from 'react';
import c from 'classnames';
import s from './ReportsDataRowMobile.scss';

interface Props {
  data: {
    label: string;
    value: string;
    className?: string;
  }[];
}
const ReportsDataRowMobile: FC<Props> = ({ data }) => {
  return (
    <div className={s['root']}>
      {data.map(({ label, value, className }, index) => (
        <div className={c(s['col'], className)} key={index}>
          <div className={s['value']}>{value}</div>
          <div className={s['label']}>{label}</div>
        </div>
      ))}
    </div>
  );
};
ReportsDataRowMobile.displayName = 'ReportsDataRowMobile';

export default ReportsDataRowMobile;
